import Icharity from "../types/services/ICharity";

export function isCurrentUserAdmin(currentCharity: Icharity): boolean {
  return currentCharity.role === "ADMIN";
}

export function isCurrentUserPublisher(currentCharity: Icharity): boolean {
  return (
    isCurrentUserAdmin(currentCharity) || currentCharity.role === "PUBLISHER"
  );
}

export function isCurrentUserCollaborator(currentCharity: Icharity): boolean {
  return (
    isCurrentUserPublisher(currentCharity) ||
    currentCharity.role === "COLLABORATOR"
  );
}

export function isCurrentUserReader(currentCharity: Icharity): boolean {
  return (
    isCurrentUserCollaborator(currentCharity) ||
    currentCharity.role === "READER"
  );
}

export function isCurrentUserOnlyCollaborator(
  currentCharity: Icharity
): boolean {
  return currentCharity.role === "COLLABORATOR";
}

export function isCurrentUserOnlyReader(currentCharity: Icharity): boolean {
  return currentCharity.role === "READER";
}

export function formatAdminRoleLabel(role: string | undefined): string {
  if (!role) {
    return "";
  }
  if (role === "COLLABORATOR") {
    return "Contributor";
  }
  if (role === "READER") {
    return "Read-Only";
  }
  return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
}
